import { OverlayModule } from "@angular/cdk/overlay";
import { NgModule } from "@angular/core";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from "@angular/material/icon";
import { MatStepperModule } from "@angular/material/stepper";
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatBadgeModule } from "@angular/material/badge";
import { MatChipsModule } from '@angular/material/chips';
import { MatMenuModule } from '@angular/material/menu';
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { FuseSidebarModule } from "@fuse/components";
import { FuseSharedModule } from "@fuse/shared.module";
import { TranslateModule } from "@ngx-translate/core";
import { DatasetModule } from "app/main/components/dataset/dataset.module";
import { FormViewerModule } from "app/main/components/form-viewer/form-viewer.module";
import { FormDialogsModule } from "app/main/dialogs/form-dialog/dialog.module";
import { PopoverModule } from "app/main/dialogs/popover/popover.module";
import { TripBookingPackagesStepComponent } from "./trip-booking-packages-step.component";
import { ActionDialogModule } from "../action-dialog/action-dialog.module";
import { ParticipantsFormComponent } from "./participants-form/participants-form.component";
import { PackageTripSelectionComponent } from "./new-trip-booking-package-selection/package-trip-selection/package-trip-selection.component";
import { NewTripBookingPackageSelectionComponent } from "./new-trip-booking-package-selection/new-trip-booking-package-selection.component";
import { ProductSelectionComponent } from "./new-trip-booking-package-selection/product-selection/product-selection.component";
import { TrenitaliaCarnetModule } from "../trenitalia-dialog/trenitalia-carnet/trenitalia-carnet.module";
import { TrenitaliaDialogModule } from "../trenitalia-dialog/trenitalia-dialog.module";
import { TripBookingPackageModule } from "./trip-booking-package/trip-booking-package.module";
import { MilanoCardSelectionComponent } from "./new-trip-booking-package-selection/milano-card-selection/milano-card-selection.component";

@NgModule({
	declarations: [
		TripBookingPackagesStepComponent,
		ParticipantsFormComponent,
		PackageTripSelectionComponent,
		ProductSelectionComponent,
		MilanoCardSelectionComponent,
		NewTripBookingPackageSelectionComponent,
	],
	imports: [
		MatFormFieldModule,
		MatInputModule,
		MatButtonModule,
		MatIconModule,
		MatStepperModule,
		MatProgressBarModule,
		FormViewerModule,
		FuseSharedModule,
		FuseSidebarModule,
		MatTabsModule,
		MatTableModule,
		MatListModule,
		DatasetModule,
		MatToolbarModule,
		MatButtonToggleModule,
		MatCardModule,
		MatTooltipModule,
		MatBadgeModule,
		MatChipsModule,
		MatMenuModule,
		MatDatepickerModule,
		MatProgressSpinnerModule,
		FormDialogsModule,
		OverlayModule,
		PopoverModule,
		ActionDialogModule,
		TrenitaliaCarnetModule,
		TrenitaliaDialogModule,
		TripBookingPackageModule,
		TranslateModule.forChild()
	],
	exports: [
		TripBookingPackagesStepComponent
	]
})
export class TripBookingPackagesStepModule{}
